import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
      display: "flex",
      flexDirection: "row",
      userSelect: "none",
      alignItems: "center",
    },
    content: {
      marginLeft: spacing.s,
    },
    title: {
      fontSize: 16,
      fontWeight: 500,
    },
    subtitle: {
      fontWeight: 500,
      color: theme.shared.contribution.default,
    },
  };

  return styles;
};
